







































































import Vue, { PropType } from 'vue';
import FieldTextArea from '@/components/form/FieldTextArea.vue';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import { ModerationCreativeForm, Ssp } from '@/types';

export default Vue.extend({
  name: 'ModerationCreativeModal',
  props: {
    sspModerations: {
      type: Array as PropType<Array<Ssp>>,
    },
    creativeId: {
      type: Number,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    sspModerations: function (sspModerations: Array<Ssp>) {
      this.form.ssp = [];
      this.modal = !!(sspModerations && sspModerations.length);
      if (!sspModerations) {
        return;
      }
      sspModerations.map((item: Ssp, index: number) => {
        const form: ModerationCreativeForm = {
          id: null,
          index: index,
          ssp_id: item.id,
          name: item.name,
          comment: '',
          status: '',
          creative_id: this.creativeId,
          errors: {},
        };
        if (item.creative_moderation) {
          form.id = item.creative_moderation.id;
          form.comment = item.creative_moderation?.comment;
          form.status = item.creative_moderation?.status?.value;
        }
        this.form.ssp.push(form);
      });
    },
    modal: function (data: boolean) {
      if (!data) {
        this.$emit('close', true);
      }
    },
  },
  components: {
    FieldCheckbox,
    FieldTextArea,
  },
  computed: {},
  methods: {
    resetError(field, index) {
      if (!this.form.ssp[index] || !this.form.ssp[index].errors[field]) {
        return;
      }
      this.form.ssp[index].errors[field] = [];
    },
    setError(index: number, field: string, message) {
      if (!this.form.ssp) {
        return;
      }
      if (!this.form.ssp[index].errors[field]) {
        Vue.set(this.form.ssp[index].errors, field, []);
      }
      this.form.ssp[index].errors[field].push(message);
    },
    changeStatus(status, index) {
      let st = '';
      if (status == this.status.APPROVE) {
        if (
          this.form.ssp[index].status === this.status.REJECT ||
          this.form.ssp[index].status == ''
        ) {
          st = this.status.APPROVE;
        }
      }
      if (status == this.status.REJECT) {
        if (
          this.form.ssp[index].status === this.status.APPROVE ||
          this.form.ssp[index].status == ''
        ) {
          st = this.status.REJECT;
        }
      }
      this.form.ssp[index].status = st;
    },
    validate() {
      let result = true;
      this.form.ssp.map((item, index) => {
        item.errors = {};
      });
      this.form.ssp.map((item, index) => {
        if (
          item.status === this.status.REJECT &&
          (!item.comment || item.comment == '')
        ) {
          result = false;
          this.setError(index, 'comment', this.$t('errors.required'));
        }
      });
      return result;
    },
    submit() {
      if (!this.validate()) {
        return;
      }
      const form = this.form.ssp.filter(
        (item: ModerationCreativeForm, index) => {
          if (
            !this.sspModerations[index] ||
            (!this.sspModerations[index].creative_moderation && item.status) ||
            (this.sspModerations[index].creative_moderation &&
              this.sspModerations[index].creative_moderation?.status.value !=
                item.status) ||
            (this.sspModerations[index].creative_moderation &&
              this.sspModerations[index].creative_moderation?.comment !=
                item.comment)
          ) {
            return true;
          }
          return false;
        }
      );
      if (!form.length) {
        return;
      }
      this.$emit('change', form);
    },
  },
  data: function () {
    return {
      modal: false,
      form: {
        ssp: [] as Array<ModerationCreativeForm>,
      },
      status: {
        APPROVE: 'approve',
        REJECT: 'reject',
      },
    };
  },
});
